import { getRequest, postRequest } from "../libs/AxiosService.util";

export async function serviceEmpDashGetCirculars(params) {
    return await getRequest('dashboard/circulars', params);
}

export async function serviceEmpDashGetQuotes(params) {
    return await getRequest('app/settings/quotes', params);
}

export async function serviceEmpDashGetDateReminders(params) {
    return await getRequest('dashboard/date/reminders', params);
}

export async function serviceEmpDashGetTiles(params) {
    return await getRequest('dashboard/employee/tiles', params);
}

export async function serviceEmpDashGetMyUpdates(params) {
    return await postRequest('employees/updates', params);
}

export async function serviceEmpDashGetNotices(params) {
    return await postRequest('notices/active-list', params);
}

export async function serviceEmpDashGetBenefitsImages() {
    return await getRequest('dashboard/benefits/images');
}

export async function serviceInterviewCounts(params) {
    return await postRequest('interviews/counts', params);
}

export async function serviceEmpDashGetMyPerformance(params) {
    return await postRequest('employees/performance', params);
}

export async function serviceEmpDashGetSalesTarget(params) {
    return await postRequest('sales/target/employee/dashboard/target/status', params);
}

export async function serviceEmpDashGetEmployeeDetails(params) {
    return await postRequest('employees/details', params);
}
